const createId = (str: string, numWords = 2) => (
  str.trim().split(' ').slice(-numWords).join('-')
);

export default createId;
